import React,{useEffect} from 'react'
import withView from '../../../cmn/docAutomation/withView';
import TaskCMNHeaderEditor from "./TaskCMNHeaderEditor"

const TaskShorthandMain = (props) => {
    const { formObject, viewData, formAction, closeModel, dsh_docid, dsh_wrksid, dshv_rowId } = props;

    const onSuccess = ()=>{
        closeModel();
    }

    const initialiseOnFormAction = () => {
        if(formAction && formAction.action){
            if (formAction.action === 'Save') {
                //fire form action with action id = save
                let saveAction = { actionId: "save", actionParam: { showModeID: 'sh', dsh_docid:dsh_docid, 
                dsh_wrksid:dsh_wrksid, dshv_rowId:dshv_rowId }, containerKey: "", onSuccess: onSuccess };
                formObject.onFormAction(saveAction, "", "");
            }
            else if (formAction.action === 'Cancel') {
                //fire form action with action id = cancel
                let cancelAction = { actionId: "cancel", actionParam: { showModeID: 'sh', dsh_docid:dsh_docid, 
                dsh_wrksid:dsh_wrksid, dshv_rowId:dshv_rowId }, containerKey: "", onSuccess: onSuccess };
                formObject.onFormAction(cancelAction, "", "");
            }
        }
    }

    useEffect(initialiseOnFormAction, [formAction]);

    if(!viewData)
        return(null);

    return (
        <div className="uiEditableContent uiShortHand">
            <TaskCMNHeaderEditor formObject={formObject} viewData={viewData} />
        </div>
    )
}

export default withView(TaskShorthandMain, "taskComp", "")